export const RFA_INIT = 'RFA_INIT';
export const RFAS_SET = 'RFAS_SET';
export const RFA_LIST_LOADING_SET = 'RFA_LIST_LOADING_SET';
export const RFA_SET = 'RFA_SET';
export const RFA_TAB_NAVIGATION_SET = 'RFA_TAB_NAVIGATION_SET';
export const RFA_LOG_PDF_SET = 'RFA_LOG_PDF_SET';
export const RFA_DELETE_CONFIRMATION_SET = 'RFA_DELETE_CONFIRMATION_SET';
export const RFA_DELETE = 'RFA_DELETE';
export const RFA_SHOW_MODAL_SET = 'RFA_SHOW_MODAL_SET';
export const RFA_SHOW_CREATE_MODAL_SET = 'RFA_SHOW_CREATE_MODAL_SET';
export const RFA_NOTES_SET = 'RFA_NOTES_SET';
export const RFA_NOTE_ADD = 'RFA_NOTE_ADD';
export const RFA_READONLY_SET = 'RFA_READONLY_SET';
export const RFA_FORM_SET = 'RFA_FORM_SET';
export const RFA_FORM_RESET = 'RFA_FORM_RESET';
export const RFA_DATA_CHANGED_SET = 'RFA_DATA_CHANGED_SET';
export const RFA_FILTERS_SHOW_SET = 'RFA_FILTERS_SHOW_SET';
export const RFA_SHOW_SIGN_MODAL_SET = 'RFA_SHOW_SIGN_MODAL_SET';
export const RFA_SIGNATURE_PREVIEW_PAGES_LOAD =
  'RFA_SIGNATURE_PREVIEW_PAGES_LOAD';
export const RFA_SIGNATURE_ADD = 'RFA_SIGNATURE_ADD';
export const RFA_SIGNATURE_UPDATE = 'RFA_SIGNATURE_UPDATE';
export const RFA_SIGNATURE_REMOVE = 'RFA_SIGNATURE_REMOVE';
export const RFA_SIGNATURE_DUPLICATE = 'RFA_SIGNATURE_DUPLICATE';
export const RFA_SIGNATURE_SET_ACTIVE = 'RFA_SIGNATURE_SET_ACTIVE';
export const RFA_SIGNATURE_CLEAR_PAGE = 'RFA_SIGNATURE_CLEAR_PAGE';
export const RFA_SIGNATURE_RESET = 'RFA_SIGNATURE_RESET';
export const RFA_SIGNATURE_SET_SUBMITTING = 'RFA_SIGNATURE_SET_SUBMITTING';
export const RFA_SHOW_SIGNING_ZONES_MODAL_SET =
  'RFA_SHOW_SIGNING_ZONES_MODAL_SET';
export const RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD =
  'RFA_SIGNING_ZONES_PREVIEW_PAGES_LOAD';
export const RFA_SIGNING_ZONE_ADD = 'RFA_SIGNING_ZONE_ADD';
export const RFA_SIGNING_ZONE_UPDATE = 'RFA_SIGNING_ZONE_UPDATE';
export const RFA_SIGNING_ZONE_REMOVE = 'RFA_SIGNING_ZONE_REMOVE';
export const RFA_SIGNING_ZONE_DUPLICATE = 'RFA_SIGNING_ZONE_DUPLICATE';
export const RFA_SIGNING_ZONE_SET_ACTIVE = 'RFA_SIGNING_ZONE_SET_ACTIVE';
export const RFA_SIGNING_ZONES_RESET = 'RFA_SIGNING_ZONES_RESET';
export const RFA_SIGNING_ZONES_SET_LOADING = 'RFA_SIGNING_ZONES_SET_LOADING';
export const RFA_SIGNING_ZONES_SET_SAVING = 'RFA_SIGNING_ZONES_SET_SAVING';
export const RFA_VOID = 'RFA_VOID';
export const RFA_UNVOID = 'RFA_UNVOID';
